import { TitleWrapper, TitleText } from './styles';

const PageTitle: React.FC<{ title: string }> = ({ title }) => (
  <TitleWrapper>
    <TitleText>{title}</TitleText>
  </TitleWrapper>
);

export default PageTitle;
